export const  storeCriteria= (searchCriteria) => {
    return ({
        type: "STORE_CRITERIA",
        payload: searchCriteria
    });
}

export const  clearCriteria= () => {
    return ({
        type: "CLEAR_CRITERIA",
        payload: []
    });
}

export const softDeleteCriteria = (deletedBy) => {
    return ({
        type: "SOFT_DEL_CRITERIA",
        payload: {deletedBy}
    });
}

export const homeLinkClicked = () => {
    return ({
        type: "HOME_LINK_CLICKED",
        payload: {}
    });
}


// WEBPACK FOOTER //
// ./components/redux/actions/SearchCritriaAction.js